import * as React from 'react';
import styled from 'styled-components';
import {
  compose,
  space,
  color,
  layout,
  typography,
  SpaceProps,
  ColorProps,
  LayoutProps,
  TypographyProps,
} from 'styled-system';
import { nanoid } from 'nanoid';
export type IconProps = SpaceProps & ColorProps & LayoutProps & TypographyProps;
const SvgComponent = React.forwardRef<
  SVGSVGElement,
  React.SVGProps<SVGSVGElement> & {
    title?: any;
  }
>(({ title, ...props }, svgRef) => {
  const [titleId] = React.useState(() => (title ? nanoid() : undefined));
  return <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" width="1em" height="1em" ref={svgRef} aria-labelledby={titleId} {...props}>{title ? <title id={titleId}>{title}</title> : null}<path fill="currentColor" fillRule="evenodd" d="M13.5415 3.4737C13.807 2.98945 13.6297 2.38161 13.1455 2.11605C12.6612 1.85049 12.0534 2.02778 11.7878 2.51203C11.4184 3.18567 10.0786 5.44986 9.23152 6.87277C8.72605 7.72187 9.25229 8.80557 10.2249 8.94173L11.5869 9.13242C11.6967 9.14778 11.772 9.25088 11.7532 9.36009L11.4587 11.0714C11.3736 11.5661 11.6684 12.0472 12.1478 12.196L14.4465 12.9097L13.1201 14.0151C12.6503 14.4065 12.4644 15.0434 12.6497 15.6261L13.0615 16.9209C13.3916 17.9585 14.3551 18.6632 15.444 18.6632H18.2173C18.6071 18.6632 18.9614 18.8897 19.125 19.2436L20.131 21.4198C20.3627 21.9211 20.957 22.1396 21.4583 21.9079C21.9596 21.6762 22.1781 21.0819 21.9464 20.5806L20.9404 18.4044C20.4497 17.3428 19.3868 16.6632 18.2173 16.6632H15.444C15.2262 16.6632 15.0335 16.5222 14.9675 16.3147L14.6568 15.3379L16.6063 13.7133C17.4455 13.014 17.176 11.663 16.1328 11.3391L13.5785 10.546L13.7242 9.6992C13.9344 8.47725 13.0921 7.32364 11.8642 7.15173L11.4285 7.09073C12.2332 5.73458 13.2187 4.06225 13.5415 3.4737ZM3.82256 14.3325L5.08735 15.5972L7.37192 13.3127C7.78886 12.8958 8.46485 12.8958 8.88178 13.3127C9.29871 13.7296 9.29871 14.4056 8.88177 14.8226L5.79911 17.9052C5.40602 18.2983 4.76869 18.2983 4.3756 17.9052L2.31271 15.8423C1.89576 15.4254 1.89577 14.7494 2.31271 14.3325C2.72964 13.9155 3.40562 13.9155 3.82256 14.3325Z" clipRule="evenodd"/></svg>;
});
export const IconSystemV2BlogPronunciationCheck = styled(SvgComponent)<IconProps>(
  {
    flex: 'none',
    verticalAlign: 'middle',
  },
  compose(space, color, layout, typography)
);
